import { OrganizationUserDetails } from "services/KnowfullyAdminClient";

export default function getUserDisplayName(
  user?: OrganizationUserDetails,
  defaultValue?: string
) {
  return user?.firstName && user?.lastName
    ? `${user.firstName} ${user.lastName}`
    : user?.email || defaultValue;
}
